import { Link } from 'react-router-dom';
import { getUserEmail, clearSession, getLogoutURL, getStoredToken, getPool, getRole, getOrgId } from '../auth/cognito';

const API_URL = 'https://0emko5cw6f.execute-api.ca-central-1.amazonaws.com/prod';

function roleLabel(role: string | null, pool: string | null): string {
  if (role === 'super_admin' && pool === 'enterprise') return 'Super Admin';
  if (role === 'super_admin' && pool === 'public')     return 'Super Admin · Public';
  if (role === 'admin')       return 'Admin';
  if (role === 'org_admin' && pool === 'enterprise')   return 'Org Admin · Enterprise';
  if (role === 'org_admin' && pool === 'public')       return 'Org Admin · Public';
  return '';
}

export default function Nav() {
  const email = getUserEmail();
  const pool  = getPool();
  const role  = getRole();
  const label = roleLabel(role, pool);

  async function logout() {
    const token = getStoredToken();
    if (token) {
      try {
        const endpoint = pool === 'public' ? `${API_URL}/pub/logout` : `${API_URL}/auth/logout`;
        await fetch(endpoint, { method: 'POST', headers: { Authorization: token } });
      } catch { /* proceed regardless */ }
    }
    clearSession();
    window.location.href = getLogoutURL();
  }

  return (
    <nav style={{
      background: 'rgba(5,13,31,0.9)', backdropFilter: 'blur(20px)',
      borderBottom: '1px solid rgba(255,255,255,0.06)',
      padding: '14px 28px', display: 'flex', alignItems: 'center',
      justifyContent: 'space-between', flexWrap: 'wrap' as const, gap: 12,
      position: 'sticky' as const, top: 0, zIndex: 100,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <span style={{ fontSize: 15, fontWeight: 700, color: '#fff' }}>
          privacy<span style={{ color: '#818cf8' }}>.education</span>
        </span>
        <span style={{
          background: 'rgba(239,68,68,0.15)', border: '1px solid rgba(239,68,68,0.3)',
          color: '#fca5a5', fontSize: 10, fontWeight: 700,
          padding: '3px 10px', borderRadius: 100, letterSpacing: 1,
        }}>ADMIN</span>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        <div style={{ textAlign: 'right' }}>
          <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.55)' }}>{email}</div>
          {label && (
            <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.25)', marginTop: 1 }}>{label}</div>
          )}
        </div>
        <button onClick={logout} style={{
          background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.12)',
          color: 'rgba(255,255,255,0.6)', padding: '6px 14px',
          borderRadius: 8, fontSize: 12, cursor: 'pointer',
        }}>Sign out</button>
        <Link to="/privacy" style={{ fontSize: 11, color: 'rgba(255,255,255,0.2)', textDecoration: 'none' }}>Privacy</Link>
      </div>
    </nav>
  );
}
